module.exports = ".mat-card-image {\n  padding: 5px 30px 5px 20px; }\n  .mat-card-image img {\n    width: inherit;\n    height: inherit;\n    margin: 0px 20px 0px 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/datainput/datainput.component.scss
// module id = ./src/app/datainput/datainput.component.scss
// module chunks = main